import { computed, type WritableComputedRef } from 'vue'

/**
 * `v-model` for a `Select` or `CheckboxGroup` over a field that holds numeric ids — pass a
 * getter and a setter over the field, and bind the result.
 *
 * Both components hand back whatever their options carried, typed `string | number`, while
 * the field and its zod schema are numbers; this is where that is coerced, so no consumer
 * has to.
 */
export function useNumericIds(
  read: () => number[],
  write: (ids: number[]) => void
): WritableComputedRef<Array<string | number>> {
  return computed({
    get: () => read(),
    set: (value) => write(Array.isArray(value) ? value.map(Number) : [])
  })
}
